import { isValidPhoneNumber } from 'libphonenumber-js';

import constants from '../constants';

export const isPhoneNumberValid = (phoneNumber) => {
  const phone = phoneNumber.toString();
  if (phone.length === 0) {
    return true;
  }

  return isValidPhoneNumber(phone, constants.currentCountry);
};
